import apiClient from "../../services/api";

export function login({ username, password }) {
  return apiClient.post("/auth/login", { username: username, password: password });
}
